import { render, staticRenderFns } from "./videoMore.vue?vue&type=template&id=3624597e&scoped=true"
import script from "./videoMore.vue?vue&type=script&lang=js"
export * from "./videoMore.vue?vue&type=script&lang=js"
import style0 from "./videoMore.vue?vue&type=style&index=0&id=3624597e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3624597e",
  null
  
)

export default component.exports